<template>
  <span v-once class="action-message-headless" style="display:none" aria-hidden="true"></span>
</template>

<script>
import language from '../language'
import { sherpaNotify } from '@/utils/toast'

export default {
  name: 'action-message',
  props: [
    'language',
    'formErrors',
    'formAddErrors',
    'formModifyErrors',
    'formSaved',
    'formAddSaved',
    'formSavedError',
    'formSavedErrorMsg',
    'formDeleted',
    'resultSuccessMsg',
    'authorization',
    'visuals',
    'apiparams',
    'visualDefinition'
  ],
  methods: {
    getLang (key) {
      return language(this.language, key)
    },
    // Dispara un toast. Respeta el flag showMessages del formulario SOLO para
    // los avisos de éxito (algunos forms silencian la confirmación); los errores
    // se muestran siempre (como el .errorMessage del comportamiento legacy).
    notify (type, message, duration) {
      if (!message) {
        return
      }
      const def = this.visualDefinition && this.visualDefinition.definition
      if (type === 'success' && def && def.showMessages === false) {
        return
      }
      sherpaNotify({ type: type, message: message, duration: duration })
    },
    buildSavedText () {
      let msg = this.getLang('formSaved')
      if (this.resultSuccessMsg) {
        msg += '<br><br>' + this.resultSuccessMsg
      }
      return msg
    }
  },
  watch: {
    formErrors (formErrors) {
      if (formErrors > 0) {
        this.notify('error', this.getLang('formErrors'), 5000)
      }
    },
    formAddErrors (formAddErrors) {
      if (formAddErrors > 0) {
        this.notify('error', this.getLang('formAddErrors'), 5000)
      }
    },
    formModifyErrors (formModifyErrors) {
      if (formModifyErrors > 0) {
        this.notify('error', this.getLang('formModifyErrors'), 5000)
      }
    },
    formSaved (formSaved) {
      if (formSaved) {
        this.notify('success', this.buildSavedText(), 3000)
      }
    },
    formSavedError (formSavedError) {
      if (formSavedError) {
        this.notify('error', this.formSavedErrorMsg, 8000)
      }
    },
    formDeleted (formDeleted) {
      if (formDeleted) {
        this.notify('success', this.getLang('formDeleted'), 3000)
      }
    }
  }
}
</script>
